var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrailing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36268 7.02904L12.25 9.91643L9.36268 12.8038L8.53767 11.9788L10.017 10.4993L2.33333 10.4998V9.33309L10.017 9.33263L8.53767 7.85399L9.36268 7.02904ZM4.63735 1.19571L5.46231 2.02067L3.983 3.49929L11.6667 3.49973V4.6664L3.983 4.66596L5.46231 6.14547L4.63735 6.97042L1.75 4.08306L4.63735 1.19571Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrailing);
export default __webpack_public_path__ + "static/media/iconTrailing.9a5ebf127d967e5dd214c77468697de1.svg";
export { ForwardRef as ReactComponent };